import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export function createTabSlice<Steps extends readonly string[]>(opts: {
	name: string;
	steps: Steps;
	initialActiveKey?: Steps[number];
}) {
	type Step = Steps[number];
	type State = { activekey: Step };

	const initialState: State = {
		activekey: (opts.initialActiveKey ?? opts.steps[0]) as Step,
	};

	const slice = createSlice({
		name: opts.name,
		initialState,
		reducers: {
			setActiveKey(_state, action: PayloadAction<Step>) {
				return { activekey: action.payload } as State;
			},
		},
	});

	return {
		reducer: slice.reducer,
		actions: slice.actions,
		steps: opts.steps,
	};
}


